import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Modal,
  Space,
  Table,
  Form,
  Flex,
  TablePaginationConfig,
} from "antd";
import instance from "../../axios/axios-instance";
import { setSuccessMessage } from "../../redux/actions/AppMessageActions";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";

type AppDispatch = ThunkDispatch<any, unknown, AnyAction>;

interface ClaimStatus {
  id: number;
  name: string;
}

function ClaimStatusTable() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isCreateModalOpen, setCreateModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [editClaimStatusForm] = Form.useForm();
  const [selectedClaimStatus, setSelectedClaimStatus] = useState<ClaimStatus>();
  const [query, setQuery] = useState("");
  const dispatch = useDispatch<AppDispatch>();

  const fetchClaimStatuses = async () => {
    const response = await instance.get("/api/administration/claim-status");
    setData(response?.data);
    setFilteredData(response?.data);
  };
  useEffect(() => {
    fetchClaimStatuses();
  }, []);

  const performSearch = () => {
    const filteredData = data.filter((claimStatus: ClaimStatus) =>
      claimStatus.name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredData(filteredData);
  };

  const resetSearch = () => {
    setQuery("");
    setFilteredData(data);
  };

  const createNewClaimStatus = async () => {
    const response = await instance.post("/api/administration/claim-status", {
      ...editClaimStatusForm.getFieldsValue(),
    });
    if (response?.status >= 200 && response?.status < 300) {
      dispatch(setSuccessMessage("Claim Status added"));
      fetchClaimStatuses();
    }
    setCreateModalOpen(false);
  };

  const editClaimStatus = async () => {
    const response = await instance.put(
      `/api/administration/claim-status?id=${selectedClaimStatus?.id}`,
      {
        ...editClaimStatusForm.getFieldsValue(),
      }
    );
    if (response?.status >= 200 && response?.status < 300) {
      dispatch(setSuccessMessage("Claim Status Updated"));
      fetchClaimStatuses();
    }
    setEditModalOpen(false);
  };

  const handleDetails = (record: any) => {
    editClaimStatusForm.setFieldsValue({
      name: record.name,
    });
    setSelectedClaimStatus(record);
    setEditModalOpen(true);
  };

  function FormIsValid() {
    const data = editClaimStatusForm.getFieldsValue();
    return data.name;
  }

  const columns: any[] = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 150,
      editable: true,
      fixed: "left",
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (record: any) => (
        <Space size="small" style={{ minWidth: "112px" }}>
          <Button onClick={() => handleDetails(record)}>Details</Button>
        </Space>
      ),
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [page_size, setPage_size] = useState(4);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    let timeoutId: any;

    // Define a function to update the window height with a delay
    const updateWindowHeight = () => {
      timeoutId = setTimeout(() => {
        setWindowHeight(window.innerHeight);
      }, 300);
    };

    // Attach the event listener when the component mounts
    window.addEventListener("resize", updateWindowHeight);

    // Remove the event listener and clear the timeout when the component unmounts
    return () => {
      window.removeEventListener("resize", updateWindowHeight);
      clearTimeout(timeoutId); // Clear any pending timeouts
    };
  }, []);

  console.log("claimStatus form", editClaimStatusForm.getFieldsValue());

  return (
    <Space direction="vertical">
      <Flex justify="space-between">
        <Space>
          <Input
            value={query}
            onChange={(e) => setQuery(e.target.value.trim())}
            placeholder="Enter search to begin"
          ></Input>
          <Button disabled={!query} onClick={() => performSearch()}>
            Search
          </Button>
          <Button
            disabled={!query.trim() || filteredData?.length === 0}
            onClick={() => resetSearch()}
          >
            Reset
          </Button>
        </Space>
        <Space align="end" direction="horizontal">
          <Button
            type="primary"
            onClick={() => {
              editClaimStatusForm.resetFields();
              setCreateModalOpen(true);
            }}
          >
            Add Claim Status
          </Button>
        </Space>
      </Flex>
      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey="id"
        scroll={{ y: windowHeight - 420 }}
        style={{ width: 650 }}
        onChange={(config: TablePaginationConfig) => {
          setPage_size(config.pageSize!);
          setCurrentPage(config.current!);
        }}
        pagination={{
          total: filteredData?.length,
          showTotal: (total) => `${total} rows`,
          pageSize: page_size,
          current: currentPage,
        }}
      />
      <Modal
        title="Create a Claim Status"
        open={isCreateModalOpen}
        onOk={createNewClaimStatus}
        okText="Save"
        /* okButtonProps={{ disabled: !FormIsValid() }} */
        onCancel={() => {
          setCreateModalOpen(false);
        }}
      >
        <Form layout="vertical" form={editClaimStatusForm}>
          <Form.Item label="Name" name="name">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Edit Claim Status"
        open={isEditModalOpen}
        onOk={editClaimStatus}
        okText="Update"
        /* okButtonProps={{ disabled: !FormIsValid() }} */
        onCancel={() => {
          setEditModalOpen(false);
        }}
      >
        <Form layout="vertical" form={editClaimStatusForm}>
          <Form.Item label="Name" name="name">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </Space>
  );
}

export default ClaimStatusTable;
